import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { TUserSawArticleEndEventParams } from './_types';

export const userSawArticleEndEvent = (
  params: TUserSawArticleEndEventParams,
) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.IN_ARTICLE_END_VIEWED,
    params,
  });
};
